import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AdminChallengeContent, Challenge, ChallengeType } from '../../../../challenges/services/models/challenges.model';
import { animationFrameScheduler, Observable, Subscription } from 'rxjs';
import { BreakpointObserver } from '@angular/cdk/layout';
import { accordionTop } from '../../../../_shared/animations/accordion-top';
import { SearchModel } from '../../../../models/search-model';
import { Router } from '@angular/router';
import dayjs from 'dayjs';
import { clamp } from 'lodash';
import { buildProgressAnimation } from '../../../../_shared/animations/progress-animation';

@Component({
  selector: 'app-home-challenge',
  templateUrl: './home-challenge.component.html',
  styleUrls: ['./home-challenge.component.scss'],
  animations: [accordionTop],
})
export class HomeChallengeComponent implements OnInit, OnDestroy {
  private static readonly COUNT_ANIM_DURATION = 1500;
  private breakpointSubscription!: Subscription;
  @Input() challenge!: Challenge<AdminChallengeContent>;

  expanded: boolean = false;
  count$: Observable<number>;

  constructor(
    private readonly breakpointObserver: BreakpointObserver,
    private readonly router: Router,
  ) { }

  ngOnInit(): void {
    this.breakpointSubscription = this.breakpointObserver.observe('(max-width: 768px)').subscribe(({  matches }) => {
      // For resolutions > 768px always show challenge description
      this.expanded = !matches;
    });

    const count = clamp(Math.round(100 * this.challenge.progress / this.challenge.target), 0, 100);
    const startTime = animationFrameScheduler.now();

    this.count$ = buildProgressAnimation(count, startTime, HomeChallengeComponent.COUNT_ANIM_DURATION);
  }

  ngOnDestroy() {
    this.breakpointSubscription.unsubscribe();
  }

  getChallengeDescriptionLabel(): string {
    if (this.challenge.type === ChallengeType.CHECKOUT_TITLES_CHALLENGE) {
      return 'user.challenges.targetCheckoutTitlesChallenge';
    }

    if (this.challenge.type === ChallengeType.TITLES_READ_CHALLENGE) {
      return 'user.challenges.targetTitlesReadChallenge';
    }

    if (this.challenge.type === ChallengeType.READING_TIME_CHALLENGE) {
      return 'user.challenges.targetReadingChallenge';
    }

    return '';
  }

  getChallengeProgressTitleLabel(): string {
    switch (this.challenge.type) {
      case ChallengeType.TITLES_READ_CHALLENGE:
      case ChallengeType.CHECKOUT_TITLES_CHALLENGE:
        return 'user.challenges.consumedContent';
      case ChallengeType.READING_TIME_CHALLENGE:
        return 'general.pluralHour';
      default:
        return '';
    }
  }

  getDaysLeft(): number | null {
    if (!this.challenge.expirationDate) {
      return 0;
    }

    return dayjs(this.challenge.expirationDate).diff(new Date(), 'day');
  }

  showContents() {
    const searchModel = new SearchModel();

    this.router.navigate(['/results'], {
      queryParams: {
        ...searchModel.toRequest(),
        title: this.challenge.name,
        showReturnButton: true,
        hideButtonsSideMenu: true,
        originPage: '/',
        challengeId: this.challenge.id,
      },
    });
  }

  toggleDescription() {
    this.expanded = !this.expanded;
  }
}
